import { v1, toResult } from '@/infrastructure/api/v1/client';
import type { SceneDto } from '@/infrastructure/api/v1/mappers/scenes';

/**
 * Copies a scene version as a draft (copyScene): into a project, owned by that project's owner, or
 * into a new project of the caller's, named `newProjectName` or "{source project} (Copy)".
 */
export async function copyScene(sceneId: string, target: { projectId: string } | { newProjectName?: string }): Promise<SceneDto> {
  // The client id makes a repeat of this request answer with the same copy
  const { data, error } = await toResult(v1.POST('/api/v1/scenes/{sceneUniqueId}/copies', {
    params: { path: { sceneUniqueId: sceneId } },
    body: { uniqueId: crypto.randomUUID(), ...('projectId' in target ? { projectUniqueId: target.projectId } : target) },
  }));
  if (error) throw error;
  return data;
}

export async function discardTemplateCopy(storyId: string): Promise<void> {
  const { error } = await toResult(v1.POST('/api/v1/stories/{storyUniqueId}/discard-template-copy', {
    params: { path: { storyUniqueId: storyId } },
  }));
  if (error) throw error;
}
